import { useState } from 'react';

import { IconButton, Tooltip } from '@mui/material';

import { Icon } from '@karehero/llama/components/atoms/Icon/Icon';

import { writeClipboard } from '@/designs-dev/loft/command';

// The one "copy this for Claude" affordance in Loft: an icon beside a name, not
// a button with a word in it. Loft is read-only, so every one of these copies a
// pointer or a command for the user to paste — see command.ts.
//
// The class is the hook a parent uses to keep it quiet until its own row is
// hovered; on a flows page there is one of these per mini, and forty always-on
// copy icons read as decoration.
export const COPY_FOR_CLAUDE_CLASS = 'copy-for-claude';

const CopyForClaude = ({
  text,
  title = 'Copy pointer for Claude',
}: {
  /** Built fresh on click, so it can read the current URL. */
  text: () => string;
  title?: string;
}) => {
  const [copied, setCopied] = useState(false);

  const copy = () => {
    writeClipboard(text());
    setCopied(true);
    window.setTimeout(() => setCopied(false), 1500);
  };

  return (
    <Tooltip title={copied ? 'Copied' : title}>
      <IconButton
        className={COPY_FOR_CLAUDE_CLASS}
        aria-label={title}
        size='small'
        onClick={copy}
      >
        <Icon icon={(copied ? 'check' : 'copy') as never} fontSize={12} />
      </IconButton>
    </Tooltip>
  );
};

export default CopyForClaude;
